import {useInfiniteQuery} from 'react-query';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';
import {getMyStoreSubBrands} from './getMyStoreSubBrands';

const useGetMyStoreSubBrands = (payload?: {
  brandId: number;
  pageSize?: number;
}) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['get-my-store-subBrands', payload],
    async ({pageParam = 1}) => getMyStoreSubBrands({pageParam, payload}),
    {
      enabled: Boolean(payload?.brandId) ?? true,
      // v3 uses this (NOT `initialPageParam`)
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage.next) return undefined;
        return allPages.length + 1;
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results);

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  };
};

export default useGetMyStoreSubBrands;
